import { render, staticRenderFns } from "./userProfile.vue?vue&type=template&id=1b861bc6&scoped=true&"
import script from "./userProfile.vue?vue&type=script&lang=js&"
export * from "./userProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b861bc6",
  null
  
)

export default component.exports